import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=f00ba12a"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f00ba12a')) {
      api.createRecord('f00ba12a', component.options)
    } else {
      api.reload('f00ba12a', component.options)
    }
    module.hot.accept("./Items.vue?vue&type=template&id=f00ba12a", function () {
      api.rerender('f00ba12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emc/table/Items.vue"
export default component.exports